import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';

const propTypes = {
  conditionOperator: PropTypes.string,
  onUpdateConditionalOperator: PropTypes.func.isRequired,
};
const defaultProps = {
  conditionOperator: '',
};

const ConditionalOperator = ({
  conditionOperator, onUpdateConditionalOperator
}) => {
  
  const toggleOptions = [
    {
      value: "and",
      label: 'AND',
    },
    {
      value: "or",
      label: 'OR',
    }
  ]
  return (
    <div className="and-or-operator new">
      <ToggleGroupButton 
        options={toggleOptions}
        defaultValue={conditionOperator}
        onChange={onUpdateConditionalOperator}
      />
    </div>
  );
};

ConditionalOperator.propTypes = propTypes;
ConditionalOperator.defaultProps = defaultProps;

export default memo(ConditionalOperator);
